import { setIn } from 'immutable';
const notInAllUsedIds = (allUsedIds, id, blackList) => {
    const isTrue = !(allUsedIds?.[0]?.includes(id) || allUsedIds?.[1]?.includes(id)) || false;
    if (!isTrue && !blackList.includes(id)) {
        blackList.push(id);
    }
    return isTrue;
};
export const getAllUsedIds = (io_extensions, object_arrays, id) => {
    const relatedList = io_extensions?.find((io) => io.id === id)?.related_list || [];
    return (object_arrays
        ?.filter((obj) => relatedList.includes(obj.id))
        .map((obj) => obj.objects_links) || []);
};
export const deleteIOExtension = (config, IOExtensionId) => {
    let newConfig = { ...config };
    const allUsedIds = getAllUsedIds(config.io_extensions, config.object_arrays, IOExtensionId);
    const blackList = [IOExtensionId];
    newConfig.heating_circuits = newConfig.heating_circuits?.filter((heating_circuits) => notInAllUsedIds(allUsedIds, heating_circuits.id, blackList));
    newConfig.pumps = newConfig.pumps?.filter((pump) => notInAllUsedIds(allUsedIds, pump.id, blackList));
    newConfig.threeway_taps = newConfig.threeway_taps?.filter((tap) => notInAllUsedIds(allUsedIds, tap.id, blackList));
    newConfig.analog_temperature_sensors = newConfig.analog_temperature_sensors?.filter((anal) => notInAllUsedIds(allUsedIds, anal.id, blackList));
    newConfig.time_intervals = newConfig.time_intervals?.filter((interval) => notInAllUsedIds(allUsedIds, interval.id, blackList));
    newConfig.interval_timetables = newConfig.interval_timetables?.filter((table) => notInAllUsedIds(allUsedIds, table.id, blackList));
    newConfig.heating_modes?.forEach((mode, index) => {
        newConfig = setIn(newConfig, ['heating_modes', index, 'heating_zones'], mode.heating_zones.filter((zone) => notInAllUsedIds(allUsedIds, zone.heating_circuit, blackList)));
    });
    newConfig.object_arrays = newConfig.object_arrays?.filter((obj) => {
        const condition = !obj.objects_links.includes(IOExtensionId);
        if (!condition) {
            blackList.push(obj.id);
        }
        return condition;
    });
    newConfig.io_extensions = newConfig.io_extensions?.filter((io) => io.id !== IOExtensionId);
    if (JSON.stringify(config) !== JSON.stringify(newConfig)) {
        return { config: newConfig, blackList };
    }
    else {
        return null;
    }
};
